import styles from "./name.module.css";

export default function Name() {
  return (
    <button
      className={`${styles.button} ${styles.name}`}
      aria-label="My name: Invitado HD"
      title="My name: Invitado HD"
    >
      <span lang="es">Invitado HD</span>
    </button>
  );
}
